// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdGptMessageQaResult = objectOf({
  response: string,
  error: string,
  ok: boolean,
});
